<form
	class="sidebar__form {{ classViewOnlyForm }}"
	[formGroup]="form"
>
	<h2 class="pax-title-h2">{{'bookingDetails.titles.frequentFlyer' | ibeadmin:'sync'}}</h2>

	<div class="form--edit-mode" *ngIf="displayMode === 'edit'">
		<div class="form-field--row grid no-padding">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<app-select-input-indra
					selectId="selectFrequentFlyer"
					placeholder="{{'bookingDetails.label.selectFrequentFlyer' | ibeadmin:'sync'}}"
					formControlName="FFid"
					id="frequent-flyer--program"
					[options]="frequentFlyerPrograms"
					selectLabel="{{'bookingDetails.alt.selectFrequentFlyer' | ibeadmin: 'sync'}}"
					label="{{'bookingDetails.label.frequentFlyerProgram' | ibeadmin:'sync'}}"
				>
				</app-select-input-indra>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formFrequentFlyerErrors('FFid') | ibeadmin:'sync'"
					*ngIf="form.controls['FFid'].invalid && form.controls['FFnum'].valid && displayValidationMessages"
				>
					{{ formFrequentFlyerErrors('FFid') | ibeadmin:'sync'}}
				</span>
			</div>

			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label"
					for="frequent-flyer--number">{{'bookingDetails.label.frequentFlyerNum' | ibeadmin:'sync'}}</label>
				<input
					class="input-text"
					formControlName="FFnum"
					id="frequent-flyer--number"
				/>
				<ng-container *ngIf="form.controls['FFid'].value && form.controls['FFnum'].value">
					<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formFrequentFlyerErrors('FFnum') | ibeadmin:'sync'"
					*ngIf="form.controls['FFnum'].invalid && form.controls['FFid'].valid && displayValidationMessages"
					>
						{{ formFrequentFlyerErrors('FFnum') | ibeadmin:'sync'}}
					</span>
				</ng-container>
			</div>
		</div>
		<a class="link right-gap" href="javascript:;" (click)="clearForm()"
			*ngIf="!isBookingPaymentPage && (hasChanges | async) && displayMode === 'edit'">
			{{'bookingDetails.text.clearDetails' | ibeadmin:'sync'}}</a>
		<a class="link" href="javascript:;" (click)="cancelEdit()"
			*ngIf="!isBookingPaymentPage && (hasChanges | async) && displayMode === 'edit'">
			{{'bookingDetails.text.cancelEditing' | ibeadmin:'sync'}}</a>

		<p class="top-gap" *ngIf="!isBookingPaymentPage">
			{{'bookingDetails.label.notTapMilesGo' | ibeadmin:'sync'}}
			<a target="_blank" class="link" (click)="INDRA_gotoURL('externalURLs.createAccountMilesGo')" href="javascript:;">{{'bookingDetails.label.registerNow' | ibeadmin:'sync'}}</a>
		</p>
		<p class="muted bottom-gap top-gap" *ngIf="isBookingPaymentPage">
			{{'bookingDetails.text.ffNameReminder' | ibeadmin:'sync'}}
		</p>
		
		<!--
		<p class="top-gap">
			{{'bookingDetails.label.notTapMilesGo' | ibeadmin:'sync'}}
			<a target="_blank" class="link" href="{{'externalURLs.createAccountMilesGo' | ibeadmincfg }}" 
				aria-label="Create an account on a new dialog">
				{{'bookingDetails.label.registerNow' | ibeadmin:'sync'}}
			</a>
		</p>
		-->
		<div class="form-field--row grid top-gap corp-fields__box">
			<div class="form-field col-12">
				<label class="checkbox-wrapper" for="show-corporate-fields">
					<input (change)="INDRA_toggleCorporateFields()" type="checkbox" class="checkbox"
						formControlName="isCorporate"
						id="show-corporate-fields">
					<span>{{'bookingDetails.label.corporatePrograms' | ibeadmin:'sync'}}</span>
				</label>
			</div>
			<div class="form-field col-6 col-tp-6 col-p-12" *ngIf="showCorpFields">
				<label class="label" for="corporate-number">{{'bookingDetails.label.corporateNumber' | ibeadmin:'sync'}}</label>
				<input
					class="input-text"
					formControlName="tapCorporateNumber"
					id="frequent-flyer--corporate-number"
					aria-describedby="corporate-number-error"
				/>
				<span
					id="corporate-number-error"
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formFrequentFlyerErrors('tapCorporateNumber') | ibeadmin:'sync'"
					*ngIf="form.controls['tapCorporateNumber'].invalid && displayValidationMessages"
				>
					{{ formFrequentFlyerErrors('tapCorporateNumber') | ibeadmin:'sync'}}
				</span>
			</div>
			<div class="col-12">
				<p class="muted bottom-gap top-gap">
					{{'bookingDetails.text.corporateProgramNote' | ibeadmin:'sync'}}
				</p>
			</div>
		</div>
		<hr class="separator">
	</div>

	<div class="form--view-mode" *ngIf="displayMode === 'view' && hasData">

		<div class="form-field--row grid no-padding">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.frequentFlyerProgram' | ibeadmin:'sync'}}</span>
				<span class="value">{{ form.value?.FFid | frequentFlyer }}</span>
			</div>
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.frequentFlyerNum' | ibeadmin:'sync'}}</span>
				<span class="value">{{ form.value?.FFnum }}</span>
			</div>
		</div>
	</div>

	<button class="button button-main-line top-gap" (click)="openEditForm()"
		*ngIf="displayMode === 'view'">
		{{'bookingDetails.text.editFrequentFlyer' | ibeadmin:'sync'}}
	</button>
</form>
